import { render, staticRenderFns } from "./ItemSelectTriggerBehaviorEditor.vue?vue&type=template&id=b4f68b64&scoped=true&"
import script from "./ItemSelectTriggerBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./ItemSelectTriggerBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSelectTriggerBehaviorEditor.vue?vue&type=style&index=0&id=b4f68b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f68b64",
  null
  
)

export default component.exports